/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../extendIcon';

const Database = props => (
  <svg viewBox="0 0 20 20" width="1em" height="1em" {...props}>
    <path d="M17 4.3v1.4C17 7 13.9 8 10 8S3 7 3 5.7V4.3C3 3 6.1 2 10 2s7 1 7 2.3zm0 3.2v3.2c0 1.3-3.1 2.3-7 2.3s-7-1-7-2.3V7.5C4.5 8.5 7.3 9 10 9s5.5-.5 7-1.5zm0 5v3.2c0 1.3-3.1 2.3-7 2.3s-7-1-7-2.3v-3.2c1.5 1 4.3 1.5 7 1.5s5.5-.5 7-1.5z" />
  </svg>
);

export default extendIcon(Database);
